<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em">To my wife, Sue, who watches me typing away at my desk, morning, noon and night, and sometimes in the middle of the night, and still manages to love me.</p><br/>
<p style="text-indent:0em">To the detectives, with their deerstalkers, clerical collars, moustaches, pistols and armchairs, may their clients never cease coming, may they solve all their cases with audacity and with elegance, and may their readers always delight.</p><br/>
<p style="text-indent:0em">And to Cleopatra, may her beauty and passion continue to uplift and haunt us, and may she always remain a mystery.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?557a37c2